const blockAlcohol = [
  //========================================================================================
  /*                                                                                      *
   *                                   STARTBLOCKALCOHOL                                  *
   *                                                                                      */
  //========================================================================================
  {
    id: "DA.1.1.14",
    shortname: "alcohol-block-subtopic",
    name: "Direction for Alcohol: Please answer the items in the grid below. Have there EVER been significant periods during which you...",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "subtopic",
    act: "ALCOHOL-BLOCK-SUBTOPIC",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
  },
  {
    id: "DA.1.1.15",
    shortname: "alcohol-block-6",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "ALCOHOL-BLOCK-6",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulfield: "true",
    link: "ALCOHOL-BLOCK-7",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-1-CONTENT",
    subtopic_name:
      "This substance is often taken in larger amounts or over a longer period than was intended",
  },
  {
    id: "DA.1.1.15.1",
    extend: "true",
    shortname: "alcohol-block-7",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "ALCOHOL-BLOCK-7",
    depending: "ALCOHOL-BLOCK-6",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-8",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-1-CONTENT",
    subtopic_name:
      "This substance is often taken in larger amounts or over a longer period than was intended",
  },
  {
    id: "DA.1.1.15.2",
    extend: "true",
    shortname: "alcohol-block-8",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-8",
    depending: "ALCOHOL-BLOCK-6",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-9",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-1-CONTENT",
    subtopic_name:
      "This substance is often taken in larger amounts or over a longer period than was intended",
  },
  {
    id: "DA.1.1.15.3",
    extend: "true",
    shortname: "alcohol-block-9",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-9",
    depending: "ALCOHOL-BLOCK-6",
    exception: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-1-CONTENT",
    subtopic_name:
      "This substance is often taken in larger amounts or over a longer period than was intended",
  },
  {
    id: "DA.1.1.16",
    shortname: "alcohol-block-10",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "ALCOHOL-BLOCK-10",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulfield: "true",
    link: "ALCOHOL-BLOCK-11",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-2-CONTENT",
    subtopic_name:
      "There is a persistent desire or unsuccessful efforts to cut down or control this substance use",
  },
  {
    id: "DA.1.1.16.1",
    extend: "true",
    shortname: "alcohol-block-11",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "ALCOHOL-BLOCK-11",
    depending: "ALCOHOL-BLOCK-10",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-12",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-2-CONTENT",
    subtopic_name:
      "There is a persistent desire or unsuccessful efforts to cut down or control this substance use",
  },
  {
    id: "DA.1.1.16.2",
    extend: "true",
    shortname: "alcohol-block-12",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-12",
    depending: "ALCOHOL-BLOCK-10",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-13",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-2-CONTENT",
    subtopic_name:
      "There is a persistent desire or unsuccessful efforts to cut down or control this substance use",
  },
  {
    id: "DA.1.1.16.3",
    extend: "true",
    shortname: "alcohol-block-13",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-13",
    depending: "ALCOHOL-BLOCK-10",
    exception: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-2-CONTENT",
    subtopic_name:
      "There is a persistent desire or unsuccessful efforts to cut down or control this substance use",
  },
  {
    id: "DA.1.1.17",
    shortname: "alcohol-block-14",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "ALCOHOL-BLOCK-14",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulfield: "true",
    link: "ALCOHOL-BLOCK-15",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-3-CONTENT",
    subtopic_name:
      "A great deal of time is spent in activities necessary to obtain this substance, use this substance, or recover from its effects",
  },
  {
    id: "DA.1.1.17.1",
    extend: "true",
    shortname: "alcohol-block-15",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "ALCOHOL-BLOCK-15",
    depending: "ALCOHOL-BLOCK-14",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-16",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-3-CONTENT",
    subtopic_name:
      "A great deal of time is spent in activities necessary to obtain this substance, use this substance, or recover from its effects",
  },
  {
    id: "DA.1.1.17.2",
    extend: "true",
    shortname: "alcohol-block-16",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-16",
    depending: "ALCOHOL-BLOCK-14",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-17",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-3-CONTENT",
    subtopic_name:
      "A great deal of time is spent in activities necessary to obtain this substance, use this substance, or recover from its effects",
  },
  {
    id: "DA.1.1.17.3",
    extend: "true",
    shortname: "alcohol-block-17",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-17",
    depending: "ALCOHOL-BLOCK-14",
    exception: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-3-CONTENT",
    subtopic_name:
      "A great deal of time is spent in activities necessary to obtain this substance, use this substance, or recover from its effects",
  },
  {
    id: "DA.1.1.18",
    shortname: "alcohol-block-18",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "ALCOHOL-BLOCK-18",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulfield: "true",
    link: "ALCOHOL-BLOCK-19",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-4-CONTENT",
    subtopic_name: "Craving, or a strong desire or urge to use this substance",
  },
  {
    id: "DA.1.1.18.1",
    extend: "true",
    shortname: "alcohol-block-19",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "ALCOHOL-BLOCK-19",
    depending: "ALCOHOL-BLOCK-18",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-30",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-4-CONTENT",
    subtopic_name: "Craving, or a strong desire or urge to use this substance",
  },
  {
    id: "DA.1.1.18.2",
    extend: "true",
    shortname: "alcohol-block-20",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-20",
    depending: "ALCOHOL-BLOCK-18",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-21",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-4-CONTENT",
    subtopic_name: "Craving, or a strong desire or urge to use this substance",
  },
  {
    id: "DA.1.1.18.3",
    extend: "true",
    shortname: "alcohol-block-21",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-21",
    depending: "ALCOHOL-BLOCK-18",
    exception: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-4-CONTENT",
    subtopic_name: "Craving, or a strong desire or urge to use this substance",
  },
  {
    id: "DA.1.1.19",
    shortname: "alcohol-block-22",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "ALCOHOL-BLOCK-22",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulfield: "true",
    link: "ALCOHOL-BLOCK-23",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-CONTENT",
    subtopic_name:
      "Recurrent use of this substance resulting in a failure to fulfill major role obligations at work, school, or home",
  },
  {
    id: "DA.1.1.19.1",
    extend: "true",
    shortname: "alcohol-block-23",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "ALCOHOL-BLOCK-23",
    depending: "ALCOHOL-BLOCK-22",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-24",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-CONTENT",
    subtopic_name:
      "Recurrent use of this substance resulting in a failure to fulfill major role obligations at work, school, or home",
  },
  {
    id: "DA.1.1.19.2",
    extend: "true",
    shortname: "alcohol-block-24",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-24",
    depending: "ALCOHOL-BLOCK-22",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-25",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-CONTENT",
    subtopic_name:
      "Recurrent use of this substance resulting in a failure to fulfill major role obligations at work, school, or home",
  },
  {
    id: "DA.1.1.19.3",
    extend: "true",
    shortname: "alcohol-block-25",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-25",
    depending: "ALCOHOL-BLOCK-22",
    exception: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-CONTENT",
    subtopic_name:
      "Recurrent use of this substance resulting in a failure to fulfill major role obligations at work, school, or home",
  },
  {
    id: "DA.1.1.20",
    shortname: "alcohol-block-26",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "ALCOHOL-BLOCK-26",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulfield: "true",
    link: "ALCOHOL-BLOCK-27",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-6-CONTENT",
    subtopic_name:
      "Continues use of this substance despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects of this substance",
  },
  {
    id: "DA.1.1.20.1",
    extend: "true",
    shortname: "alcohol-block-27",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "ALCOHOL-BLOCK-27",
    depending: "ALCOHOL-BLOCK-26",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-28",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-6-CONTENT",
    subtopic_name:
      "Continues use of this substance despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects of this substance",
  },
  {
    id: "DA.1.1.20.2",
    extend: "true",
    shortname: "alcohol-block-28",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-28",
    depending: "ALCOHOL-BLOCK-26",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-29",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-6-CONTENT",
    subtopic_name:
      "Continues use of this substance despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects of this substance",
  },
  {
    id: "DA.1.1.20.3",
    extend: "true",
    shortname: "alcohol-block-29",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-29",
    depending: "ALCOHOL-BLOCK-26",
    exception: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-6-CONTENT",
    subtopic_name:
      "Continues use of this substance despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects of this substance",
  },
  {
    id: "DA.1.1.21",
    shortname: "alcohol-block-30",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "ALCOHOL-BLOCK-30",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulfield: "true",
    link: "ALCOHOL-BLOCK-31",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-7-CONTENT",
    subtopic_name:
      "Important social, occupational, or recreational activities are given up or reduced because of this substance use",
  },
  {
    id: "DA.1.1.21.1",
    extend: "true",
    shortname: "alcohol-block-31",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "ALCOHOL-BLOCK-31",
    depending: "ALCOHOL-BLOCK-30",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-32",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-7-CONTENT",
    subtopic_name:
      "Important social, occupational, or recreational activities are given up or reduced because of this substance use",
  },
  {
    id: "DA.1.1.21.2",
    extend: "true",
    shortname: "alcohol-block-32",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-32",
    depending: "ALCOHOL-BLOCK-30",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-33",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-7-CONTENT",
    subtopic_name:
      "Important social, occupational, or recreational activities are given up or reduced because of this substance use",
  },
  {
    id: "DA.1.1.21.3",
    extend: "true",
    shortname: "alcohol-block-33",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-33",
    depending: "ALCOHOL-BLOCK-30",
    exception: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-7-CONTENT",
    subtopic_name:
      "Important social, occupational, or recreational activities are given up or reduced because of this substance use",
  },
  {
    id: "DA.1.1.22",
    shortname: "alcohol-block-34",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "ALCOHOL-BLOCK-34",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulfield: "true",
    link: "ALCOHOL-BLOCK-35",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-8-CONTENT",
    subtopic_name:
      "Recurrent use of this substance in situations in which it is physically hazardous",
  },
  {
    id: "DA.1.1.22.1",
    extend: "true",
    shortname: "alcohol-block-35",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "ALCOHOL-BLOCK-35",
    depending: "ALCOHOL-BLOCK-34",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-36",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-8-CONTENT",
    subtopic_name:
      "Recurrent use of this substance in situations in which it is physically hazardous",
  },
  {
    id: "DA.1.1.22.2",
    extend: "true",
    shortname: "alcohol-block-36",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-36",
    depending: "ALCOHOL-BLOCK-34",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-37",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-8-CONTENT",
    subtopic_name:
      "Recurrent use of this substance in situations in which it is physically hazardous",
  },
  {
    id: "DA.1.1.22.3",
    extend: "true",
    shortname: "alcohol-block-37",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-37",
    depending: "ALCOHOL-BLOCK-34",
    exception: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-8-CONTENT",
    subtopic_name:
      "Recurrent use of this substance in situations in which it is physically hazardous",
  },
  {
    id: "DA.1.1.23",
    shortname: "alcohol-block-38",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "ALCOHOL-BLOCK-38",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulfield: "true",
    link: "ALCOHOL-BLOCK-39",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-9-CONTENT",
    subtopic_name:
      "Use of this substance is continued despite knowledge of having a persistent or recurrent physical or psychological problem that is likely to have been caused or exacerbated by this substance",
  },
  {
    id: "DA.1.1.23.1",
    extend: "true",
    shortname: "alcohol-block-39",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "ALCOHOL-BLOCK-39",
    depending: "ALCOHOL-BLOCK-38",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK0",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-9-CONTENT",
    subtopic_name:
      "Use of this substance is continued despite knowledge of having a persistent or recurrent physical or psychological problem that is likely to have been caused or exacerbated by this substance",
  },
  {
    id: "DA.1.1.23.2",
    extend: "true",
    shortname: "alcohol-block-40",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-40",
    depending: "ALCOHOL-BLOCK-38",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-41",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-9-CONTENT",
    subtopic_name:
      "Use of this substance is continued despite knowledge of having a persistent or recurrent physical or psychological problem that is likely to have been caused or exacerbated by this substance",
  },
  {
    id: "DA.1.1.23.3",
    extend: "true",
    shortname: "alcohol-block-41",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-41",
    depending: "ALCOHOL-BLOCK-38",
    exception: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-9-CONTENT",
    subtopic_name:
      "Use of this substance is continued despite knowledge of having a persistent or recurrent physical or psychological problem that is likely to have been caused or exacerbated by this substance",
  },
  {
    id: "DA.1.1.24",
    shortname: "alcohol-block-42",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "ALCOHOL-BLOCK-42",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulfield: "true",
    link: "ALCOHOL-BLOCK-43",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-10-CONTENT",
    subtopic_name:
      "Tolerance, as defined by either of the following:-A need for markedly increased amounts of this substance to achieve intoxication or desired effect; - A markedly diminished effect with continued use of the same amount of this substance",
  },
  {
    id: "DA.1.1.24.1",
    extend: "true",
    shortname: "alcohol-block-43",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "ALCOHOL-BLOCK-43",
    depending: "ALCOHOL-BLOCK-42",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-44",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-10-CONTENT",
    subtopic_name:
      "Tolerance, as defined by either of the following:-A need for markedly increased amounts of this substance to achieve intoxication or desired effect; - A markedly diminished effect with continued use of the same amount of this substance",
  },
  {
    id: "DA.1.1.24.2",
    extend: "true",
    shortname: "alcohol-block-44",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-44",
    depending: "ALCOHOL-BLOCK-42",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-45",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-10-CONTENT",
    subtopic_name:
      "Tolerance, as defined by either of the following:-A need for markedly increased amounts of this substance to achieve intoxication or desired effect; - A markedly diminished effect with continued use of the same amount of this substance",
  },
  {
    id: "DA.1.1.24.3",
    extend: "true",
    shortname: "alcohol-block-45",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-45",
    depending: "ALCOHOL-BLOCK-42",
    exception: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-10-CONTENT",
    subtopic_name:
      "Tolerance, as defined by either of the following:-A need for markedly increased amounts of this substance to achieve intoxication or desired effect; - A markedly diminished effect with continued use of the same amount of this substance",
  },
  {
    id: "DA.1.1.25",
    shortname: "alcohol-block-46",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "ALCOHOL-BLOCK-46",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulfield: "true",
    link: "ALCOHOL-BLOCK-47",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-11-CONTENT",
    subtopic_name:
      "Withdrawal, as manifested by either of the following: - The characteristic withdrawal syndrome for this substance; - Other substance(s)is/are taken to relieve or avoid withdrawal symptoms",
  },
  {
    id: "DA.1.1.25.1",
    extend: "true",
    shortname: "alcohol-block-47",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "ALCOHOL-BLOCK-47",
    depending: "ALCOHOL-BLOCK-46",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-48",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-11-CONTENT",
    subtopic_name:
      "Withdrawal, as manifested by either of the following: - The characteristic withdrawal syndrome for this substance; - Other substance(s)is/are taken to relieve or avoid withdrawal symptoms",
  },
  {
    id: "DA.1.1.25.2",
    extend: "true",
    shortname: "alcohol-block-48",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-48",
    depending: "ALCOHOL-BLOCK-46",
    exception: "This has happened",
    link: "ALCOHOL-BLOCK-49",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-11-CONTENT",
    subtopic_name:
      "Withdrawal, as manifested by either of the following: - The characteristic withdrawal syndrome for this substance; - Other substance(s)is/are taken to relieve or avoid withdrawal symptoms",
  },
  {
    id: "DA.1.1.25.3",
    extend: "true",
    shortname: "alcohol-block-49",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "ALCOHOL-BLOCK-49",
    depending: "ALCOHOL-BLOCK-46",
    exception: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-11-CONTENT",
    subtopic_name:
      "Withdrawal, as manifested by either of the following: - The characteristic withdrawal syndrome for this substance; - Other substance(s)is/are taken to relieve or avoid withdrawal symptoms",
  },
  {
    id: "DA.1.1.26",
    shortname: "alcohol-block-50",
    name: "Number of criteria met for :",
    prevalue: "Number of criteria met for Alcohol:",
    value: "0",
    disabled: "true",
    type: "content",
    comment: "Consider no diagnosis for Alcohol",
    act: "ALCOHOL-BLOCK-50",
    depending: "DA0",
    exception: "Alcohol",
    condition: "in",
    meaningfulcount: "This has happened",
    subtopic_container_act: "ALCOHOL-BLOCK-SUBTOPIC",
    suptopic_code: "ALCOHOL-BLOCK-12-CONTENT",
    subtopic_name: "Content Criteria",
  },
  //========================================================================================
  /*                                                                                      *
   *                                    ENDBLOCKALCOHOL                                   *
   *                                                                                      */
  //========================================================================================
];

export default blockAlcohol;
